import {
  GET_LOAN,
  GET_LOAN_SUCCESS,
  GET_LOAN_FAIL,
  DELETE_LOAN,
  DELETE_LOAN_SUCCESS,
  DELETE_LOAN_FAIL,
  UPDATE_LOAN,
  UPDATE_LOAN_SUCCESS,
  UPDATE_LOAN_FAIL,
  ADD_NEW_LOAN,
  ADD_LOAN_SUCCESS,
  ADD_LOAN_FAIL,
  LOAN_LOADING,
  LOAN_RESET,
} from "./actionType";

export const resetLoanState = (actionType) => ({
  type: LOAN_RESET,
  payload: { actionType },
});

export const getLoanSuccess = (actionType, data) => ({
  type: GET_LOAN_SUCCESS,
  payload: { actionType, data },
});

export const getLoanFail = (actionType, error) => ({
  type: GET_LOAN_FAIL,
  payload: { actionType, error },
});

export const getLoan = data => ({
  type: GET_LOAN,
  payload: data,
});

export const getLoanLoading = () => ({
  type: LOAN_LOADING
});

export const deleteLoan = data => ({
  type: DELETE_LOAN,
  payload: data,
});

export const deleteLoanSuccess = data => ({
  type: DELETE_LOAN_SUCCESS,
  payload: data,
});

export const deleteLoanFail = error => ({
  type: DELETE_LOAN_FAIL,
  payload: error,
});

export const updateLoan = data => ({
  type: UPDATE_LOAN,
  payload: data,
});

export const updateLoanFail = error => ({
  type: UPDATE_LOAN_FAIL,
  payload: error,
});

export const updateLoanSuccess = data => ({
  type: UPDATE_LOAN_SUCCESS,
  payload: data,
});

export const addNewLoan = data => ({
  type: ADD_NEW_LOAN,
  payload: data,
});

export const addLoanSuccess = data => ({
  type: ADD_LOAN_SUCCESS,
  payload: data,
});

export const addLoanFail = error => ({
  type: ADD_LOAN_FAIL,
  payload: error,
});